<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img">
      <div class="img_tit hidden-xs-only">智能制造核心：MES系统赋能未来</div>
      <div class="img_desc hidden-xs-only">
        MES（制造执行系统）是智能制造的核心，提升效率、降低成本，赋能制造业智能化转型与高质量发展。
      </div>
    </div>
    <div style="z-index:9;position:relative;display:none;">
      <Affix :offset-top="56">
        <Menu
          :active-name="selectName"
          class="enter_menu_wrap"
          mode="horizontal"
          theme="light"
          @on-select="selectMenuItem"
        >
          <MenuItem
            class="enter_menu_item"
            name="1"
          >
          BioMall - 生物医药产业创新服务综合体
          </MenuItem>
          <MenuItem
            class="enter_menu_item"
            name="2"
          >
          医疗器械创新示范基地
          </MenuItem>
        </Menu>
      </Affix>
    </div>
    <div class="current_show_menu">
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_left">
            <img
              alt=""
              src="../../assets/img/tupianright.png"
            />
          </div>

        </div>
      </div>
      <Row
        :gutter="20"
        class-name="enter_card_wrap hidden-xs-only"
        justify="center"
      >

      </Row>
      <div class="enter_card_wrap_mobile hidden-sm-and-up">
        <img
          alt=""
          src="@/assets/img/16f7580f76.png"
        />
      </div>
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_left">
            <img
              alt=""
              src="../../assets/img/tupianright.png"
            />
          </div>
          <div class="inner_center">
            <div class="enter_title">走进新装备</div>
            <div class="enter_desc"></div>
          </div>
          <div class="inner_right">
            <img
              alt=""
              src="../../assets/img/tupianleft.png"
            />
          </div>
        </div>
      </div>
      <div class="mall_wrap">
        <div class="mall_img">
          <img
            alt=""
            src="@/assets/img/rich.png"
          />
        </div>
        <div class="mall_details">
          <p>
            走进智能化 MES 系统，首先映入眼帘的是数据实时交互的 “高速通道”。通过遍布生产车间的传感器、智能设备，生产过程中的每一个细节，从设备运行参数到物料流转信息，都能瞬间汇聚于此。它让生产状况变得 “透明”，管理者能随时掌握进度、质量等关键指标。
          </p>
          <div class="mall_btn">
            <el-button
              class="btn_self"
              @click="gotoDemo"
            >了解更多</el-button>
          </div>
        </div>
      </div>
      <div class="func_wrap">
        <div class="func_wrap_inner">
          <div class="func_tit">新装备 功能体系</div>
          <el-row
            class="func_card hidden-xs-only"
            type="flex"
          >
            <el-col
              v-for="(item, index) in funcCardList"
              :key="index"
              :span="5"
              class="card_item"
            >
              <div
                :style="{'background':`url(${item.bg})`}"
                class="item_top"
              >
                <p>{{ item.tit }}</p>
              </div>
              <div class="item_bottom">
                <p
                  v-for="(item2, index2) in item.desc"
                  :key="index2"
                >
                  {{ '○  ' + item2 }}
                </p>
              </div>
            </el-col>
          </el-row>
          <div class="func_card_mobile hidden-sm-and-up">
            <img
              alt=""
              src="@/assets/img/3572170410.png"
            />
          </div>
          <div class="func_card_mobile hidden-sm-and-up">
            <img
              alt=""
              src="@/assets/img/3572170410.png"
            />
          </div>
          <div class="func_card_mobile hidden-sm-and-up">
            <img
              alt=""
              src="@/assets/img/3572170410.png"
            />
          </div>
        </div>
      </div>
      <div
        class="func_wrap"
        style="background: #f4f9fc"
      >
        <div class="func_wrap_inner">
          <div class="func_tit">新装备 四大核心价值</div>
        </div>
        <div class="double_card_wrap">
          <el-row
            class="double_card"
            type="flex"
          >
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <p>优化生产效率：智能排程调配，提速降本</p>
            </el-col>
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <p>保障产品质量：全流程管控，追溯改进。</p>
            </el-col>
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <p>提升决策科学性：分析生产数据，精准决策。</p>
            </el-col>
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <p>强化供应链协同：打通信息壁垒，协同共赢。</p>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 平台介绍 -->
      <div
        class="func_wrap"
        style="background: #f4f9fc"
      >
        <div class="func_wrap_inner">
          <div class="func_tit">成熟智能MES系统，赋能高效定制化制造</div>
        </div>
        <div class="double_card_wrap">
          <el-row
            class="double_card"
            type="flex"
          >
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <img
                src="@/assets/mes1.png"
                alt=""
              >
            </el-col>
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <img
                src="@/assets/mes2.png"
                alt=""
              >

            </el-col>
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <img
                src="@/assets/mes3.png"
                alt=""
              >
            </el-col>
            <el-col
              :span="5"
              :xs="11"
              class="double_card_item"
            >
              <div class="double_card_bg"></div>
              <img
                src="@/assets/mes5.png"
                alt=""
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  data () {
    return {
      selectName: '1',
      funcCardList: [
        {
          tit: '生产计划与调度',
          desc: [
            '承接上层指令，结合实时数据智能编排、调整生产任务 ',
            '依据多源实时数据，智能排产并灵活应对设备故障等状况',
            '接收计划指令，靠实时数据动态规划、调整生产排程',
            'AI/大数据线上精准匹配服务',
          ],
          bg: require('../../assets/img/bg1.png')
        },
        {
          tit: '生产过程监控',
          desc: [
            '借助物联网实现可视化监控与异常处理',
            '实时查看各环节状态,迅速定位根源，保障生产顺畅',
          ],
          bg: require('../../assets/img/bg2.png')
        },
        {
          tit: '质量管理',
          desc: [
            '智能设备严检原材料，存档数据',
            '工序传感器采数据，精准追溯问题',
            '成品全检生成报告，挖掘风险点',
          ],
          bg: require('../../assets/img/bg3.png')
        },
        {
          tit: '供应链协同',
          desc: [
            '对接内外系统，促数据实时交互',
            '传递关键信息，让协同决策更准',
            '依共享信息，协同应对供需变化',
          ],
          bg: require('../../assets/img/bg3.png')
        },
      ],
    }
  },
  methods: {
    selectMenuItem (name) {
      console.log(name)
    },
    gotoDemo () {
      this.$router.push('/demo')
    }
  },
  components: {
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;

  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/img/banner22.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .enter_menu_wrap {
    @media screen and (max-width: 768px) {
      height: 40px;
    }

    .enter_menu_item {
      width: 50%;
      text-align: center;
      font-size: 22px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .enter_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .enter_inner {
      display: flex;
      justify-content: center;

      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }

      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }

        .enter_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .enter_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }

      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }
    }
  }

  .current_show_menu {
    .enter_card_wrap_mobile {
      width: 100%;

      img {
        width: 100%;
      }
    }

    .enter_card_wrap {
      width: 100%;
      margin-top: 50px;

      .enter_card_item {
        background: #f4f9fc;
        text-align: center;

        p {
          width: 60%;
          text-align: center;
          margin: 0 auto;
          font-size: 16px;
        }

        .title {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }

    .mall_wrap {
      width: 70%;
      display: flex;
      justify-content: center;
      margin: 34px auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      @media screen and (max-width: 768px) {
        flex-direction: column;
      }

      .mall_img {
        width: 50%;
        margin-right: 30px;
        padding: 0 30px;
        @media screen and (max-width: 768px) {
          width: 100%;
        }

        img {
          width: 100%;
        }
      }
    }

    .mall_details {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media screen and (max-width: 768px) {
        width: 90%;
        text-align: center;
      }

      p {
        font-size: 20px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }

      .mall_btn {
        margin-top: 40px;
        @media screen and (max-width: 768px) {
          padding: 20px 0;
        }

        .btn_self {
          background: orange;
          color: #fff;
          border-radius: 20px;
          border: none;
          @media screen and (max-width: 768px) {
            width: 80px;
            height: 35px;
            border-radius: 20px;
            font-size: 14px;
          }
        }
      }
    }
  }

  .func_wrap {
    width: 100%;
    padding: 50px;
    background: url("../../assets/img/bg_0.png");
    background-size: 100% 100%;

    .func_wrap_inner {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .func_tit {
        font-size: 34px;
        font-weight: bold;
        text-align: center;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }

      .func_card {
        justify-content: space-between;
        margin-top: 40px;

        .card_item {
          background: #fff;
          box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.1);

          .item_top {
            width: 100%;
            height: 150px;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .item_bottom {
            padding: 15px;

            p {
              font-size: 16px;
              margin-top: 20px;
            }
          }
        }
      }

      .func_card_mobile {
        width: 100%;

        img {
          width: 100%;
          margin-top: 40px;
        }
      }
    }

    .double_card_wrap {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .double_card {
        justify-content: space-between;
        margin-top: 50px;
        @media screen and (max-width: 768px) {
          flex-wrap: wrap;
        }

        .double_card_item {
          height: 250px;
          background: rgba($color: #fff, $alpha: 1);
          padding: 30px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          > img {
            width: 300px;
            height: 300px;
            margin-top: 10px;
          }

          &:nth-child(1) {
            background-image: url("../../assets/img/bg_1.png");
          }

          &:nth-child(2) {
            background-image: url("../../assets/img/bg_2.png");
          }

          &:nth-child(3) {
            background-image: url("../../assets/img/bg_3.png");
          }

          &:nth-child(4) {
            background-image: url("../../assets/img/bg_4.png");
          }

          background-position: 100% 100%;
          background-repeat: no-repeat;
          background-size: 30%;
          @media screen and (max-width: 768px) {
            height: 140px;
            &:nth-child(n + 3) {
              margin-top: 20px;
            }
          }

          .double_card_bg {
            width: 30px;
            height: 15px;
            background: linear-gradient(90deg, rgba(252, 197, 96, 0), #feb15a);
            @media screen and (max-width: 768px) {
              width: 20px;
              height: 8px;
            }
          }

          p {
            line-height: 20px;
            font-size: 15px;
            margin-top: 30px;
            @media screen and (max-width: 768px) {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}
</style>